<template>

  <v-card class="elevation-1 login-wrapper">
    <v-card-title>U wordt nu uitgelogd..</v-card-title>
  </v-card>

</template>

<script>
export default {
  name: "Logout",
  mounted () {
    let $vue = this
    // Logout user with a confirmation if needed
    $vue.logoutConfirm()
  },
  methods: {
    async logoutConfirm() {
      // Check if there are registrations in the outbox
      let outboxRegistrations = this.$store.getters['registrationOutbox/getItems'](999)
      if (outboxRegistrations.length > 0) {
        if (confirm('Waarschuwing! U heeft nog lokaal opgeslagen registraties die niet in de cloud staan. Als u uitlogt, gaan deze verloren. Weet u zeker dat u wilt uitloggen?')) {
          this.logout();
        }
        else {
          // User cancelled logout, go to dashboard
          this.$router.push({name: 'dashboard'});
        }
      }
      else {
        // No outbox registrations, just logout
        this.logout();
      }
    },
    logout() {
      this.$store.dispatch('LogOut')
      this.$router.push({name: 'login'})
    }
  }
};
</script>

<style lang="scss" scoped>
.login-wrapper {
  max-width: 400px;
  margin: 10vh auto;
}
</style>